module.exports = __webpack_public_path__ + "img/sg.7083c35e.svg";